import LighthouseScript from '.';
import '@html/serp/lighthouse/styles.scss';
import '@html/serp/lighthouse/async.scss';
import '@html/serp/lighthouse/uncritical.scss';
import '@html/serp/lighthouse/uncritical-no-content.scss';

if (import.meta.webpackHot) {
  import.meta.webpackHot.addStatusHandler((status) => status === 'apply' && console.clear());
  import.meta.webpackHot.accept();
}

window.addEventListener('load', () => {
  const lighthouse = new LighthouseScript();
  lighthouse.initiate();
});
